module.exports = __webpack_public_path__ + "static/slackcomms.a46e03f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/slackcomms.png
// module id = 441
// module chunks = 65579394461380